export enum XpressDisciplinaryActionEnum {
    None = 0,
    Closed = 1,
    Suspension = 2,
    Ban = 3,
    TemporarySuspended = 4
}
